import { useRanchesByCustomer } from '../../../../services/entities/hooks/useRanchesByCustomer';
import { useStages } from '../../../../services/entities/hooks/useStages';
import { useVariety } from '../../../../services/entities/hooks/useVariety';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { useDownloadCsv } from '../../../duckDB/hooks/useDownloadCsv';
import { createInlineMappingSubquery } from '../../../duckDB/utils/createInlineMappingSubquery';
import { formattedDateColumn } from '../../../duckDB/utils/formattedDateColumn';

export const useDownloadStageReport = (
  customerId: string,
  varietyId: string | undefined,
  shouldUpdate: boolean
) => {
  const { t } = useTranslation();

  const { variety } = useVariety(varietyId);

  const { stages, isStagesLoading } = useStages(varietyId);

  const { ranches, isRanchesLoading } = useRanchesByCustomer(customerId);

  const ranchesSubquery = createInlineMappingSubquery(ranches, ['id', 'name']);

  return useDownloadCsv(
    `(SELECT "${t('Scan Date')}", "${t('Ranch')}", "${t('Block')}", "${t(
      'Total Count'
    )}", "${t('Per Plant Count')}", "${t('Stage')}" FROM (
      SELECT * FROM (
        SELECT
          ${formattedDateColumn('report.scan_date')} as '${t('Scan Date')}', 
          ranches.name as '${t('Ranch')}',
          report.block_name as '${t('Block')}', 
          CAST(round(CAST(report.stage_count AS FLOAT), 0) AS INTEGER) as '${t(
            'Total Count'
          )}',
          CAST(round(CAST(report.count_per_plant AS FLOAT), 0) AS INTEGER) as '${t(
            'Per Plant Count'
          )}',
          stages.name as '${t('Stage')}',
          stages._ord
        FROM stage_report_table report 
        LEFT JOIN ${ranchesSubquery} ranches 
        ON (report.ranch_id = ranches.id)
        LEFT JOIN ${createInlineMappingSubquery(
          stages,
          ['id', 'name', 'order'],
          'stages(id, name, _ord)'
        )} stages 
        ON (report.stage_id = stages.id)

        UNION ALL

        SELECT
          ${formattedDateColumn('report.scan_date')},
          ranches.name,
          report.block_name,
          CAST(round(SUM(CAST(report.stage_count AS FLOAT)), 0) AS INTEGER),
          CAST(round(SUM(CAST(report.count_per_plant AS FLOAT)), 0) AS INTEGER),
          '${t('Total')}',
          9999 as _ord
        FROM stage_report_table report 
        JOIN ${ranchesSubquery} ranches ON (report.ranch_id = ranches.id)
        GROUP BY report.scan_date, ranches.name, report.block_name
      ) stage_rows_with_total
      ORDER BY 1, 3, 7
    ))`,
    `${variety?.name.toLowerCase() ?? 'blueberry'}_${t(
      'stage report'
    ).replaceAll(' ', '_')}`,
    shouldUpdate && !(isRanchesLoading || isStagesLoading)
  );
};
